import {Temp} from "../utils/Temp.js";

export class TypeSearch {
	query;
	input;
	container;
	enabled;

	/**
	 * @param focusableInput
	 * @param container
	 * @param callback - receives filter query ... query cancel is empty string
	 */
	constructor(focusableInput, container, callback) {
		this.query = "";
		this.input = focusableInput;
		this.container = container;
		this.callback = callback;
		/** @type {jQuery} */
		this.display = null;
		this.enabled = true;

		this.input.on('focus', this.onFocus.bind(this))
			.on('blur', this.onBlur.bind(this))
	}

	setQuery(q) {
		if (!this.enabled) return;
		this.query = q;
		// Update screen
		if (this.query.length === 0) {
			if (this.display) {
				this.display.remove();
				this.display = null;
			}
		} else {
			if (!this.display) {
				this.display = Temp.tag("div", { clazz: 'type-search' });
				this.container.prepend(this.display);
			}
			this.display.text(this.query);
		}
		this.callback(this.query);
	}

	insertData(chars) {
		this.setQuery(this.query + chars);
	}

	removeChar() {
		if (this.query.length > 0) this.setQuery(this.query.substring(0, this.query.length - 1));
	}

	onFocus(e) {
		this.input.on('keydown.ts', this.onBeforeInput.bind(this));
	}

	onBlur(e) {
		this.input.off('keydown.ts');
	}

	onBeforeInput(e) {
		//console.dir(e);
		const key = e.originalEvent.key;
		if (key) {
			if (key.length === 1 /* on char */) this.insertData(key);
			else if (key === "Backspace") this.removeChar();
			else if (key === "Escape") this.clear();
		}
	}

	/**
	 * Reset state to "no search"
	 */
	clear() {
		this.setQuery("");
	}

	enable(enable = true) {
		this.enabled = enable;
		if (!enable) this.clear();
	}
}